import styles from './index.module.scss';
import EcoSpace from 'eco-design/base/eco-space';
import { productType } from '@elem/compPage/delta-3-series/config/pageConfig';
import { useEffect, useState } from 'react';
import { useLang } from '@/app/utils/useLang';
import gtm from '@/utils/gtm';
import EcoImg from 'eco-design/base/eco-img';

export default function Covered() {
    const { t } = useLang('Covered');
    const [active, setActive] = useState(1);
    const cards = [
        {
            img: 'https://websiteoss.ecoflow.com/figma-uploads/1758856906382-j92g8z-compressed-Frame%202094654381.jpg',
            imgh5: 'https://websiteoss.ecoflow.com/figma-uploads/1758857018833-nicks4-compressed-Frame%201000008499.jpg',
            title: t('Covered_item1_label'),
            desc: t('Covered_item1_title'),
            id: productType.D3U,
        },
        {
            img: 'https://websiteoss.ecoflow.com/figma-uploads/1758856940982-1fr3il-compressed-Frame%202094654382.jpg',
            imgh5: 'https://websiteoss.ecoflow.com/figma-uploads/1761211664851-ha8kjq-compressed-Frame%201000008500.jpg',
            title: t('Covered_item2_label'),
            desc: t('Covered_item2_title'),
            id: productType.D3M,
        },
        {
            img: 'https://websiteoss.ecoflow.com/figma-uploads/1758856959088-bzuw2e-compressed-Frame%20161270185.jpg',
            imgh5: 'https://websiteoss.ecoflow.com/figma-uploads/1761211630254-luywyx-compressed-Frame%201000008501.jpg',
            title: t('Covered_item3_label'),
            desc: t('Covered_item3_title'),
            id: productType.D3C,
        },
    ];

    const handleScoll = (id: string, title: string, index: number) => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'click_anchor',
            position: title,
            button_name: title,
            __btn_id1: `${styles.Covered} .card-${index + 1}`,
            __btn_id2: id,
            __btn_type: 'common',
        });
        document.getElementById(id)?.scrollIntoView({
            behavior: 'smooth',
        });
    };
    const [show, setShow] = useState(false);

    let interObserver: IntersectionObserver | null;
    useEffect(() => {
        const apperCb: IntersectionObserverCallback = (params: IntersectionObserverEntry[]) => {
            const data = params[0];
            const calIconStatus = data.intersectionRatio > 0.1;
            calIconStatus && setShow(calIconStatus);
        };
        interObserver && interObserver.disconnect();
        interObserver = new IntersectionObserver(apperCb, {
            threshold: [0.1], // 触发阈值（10%）
        });

        const div = document.querySelector('#Covered');
        if (div) {
            interObserver.observe(div as HTMLElement);
        }

        return () => {
            interObserver && interObserver.disconnect();
        };
    }, []);

    return (
        <div className={`${styles.Covered} eco-content ${show ? 'show' : ''} GtmModuleData-section`} id="Covered" data-section-id="Covered">
            <EcoSpace />
            <div className="text-box">
                <p className="text-title fade-in" style={{ animationDelay: '200ms' }}>
                    {t('Covered_title')}
                </p>
            </div>
            <ul className="card-box ">
                {cards?.map((card, index: number) => (
                    <li
                        className={`fade-in card card-${index + 1} GtmModuleData-btn-common ${index === active ? 'active' : ''}`}
                        data-btn-id={card.id}
                        key={index}
                        onMouseEnter={() => setActive(index)}
                        onClick={() => handleScoll(card.id, card.title, index)}
                        style={{ animationDelay: `${200 * (index + 2)}ms` }}
                    >
                        <div className="card-img">
                            <EcoImg isOpenLazy pc={card.img} h5={card.imgh5} />
                        </div>
                        <div className="card-text">
                            <div>
                                <p className="card-title">{card.title}</p>
                                <p className="card-desc">{card.desc}</p>
                            </div>
                            <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clipPath="url(#clip0_4884_44002)">
                                    <rect width="28" height="28" rx="14" fill="white" fillOpacity="0.2" />
                                    <path d="M21 11.667L14 18.667L7 11.667" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_4884_44002">
                                        <rect width="28" height="28" rx="14" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
}
